import { render, staticRenderFns } from "./project_setting.vue?vue&type=template&id=f810dd68&scoped=true&"
import script from "./project_setting.vue?vue&type=script&lang=js&"
export * from "./project_setting.vue?vue&type=script&lang=js&"
import style0 from "./project_setting.vue?vue&type=style&index=0&id=f810dd68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f810dd68",
  null
  
)

export default component.exports